import { render, staticRenderFns } from "./RsaSchedaRelazioneSanitariaApparatoUrogenitaleEditComponent.vue?vue&type=template&id=2688a7f7"
import script from "./RsaSchedaRelazioneSanitariaApparatoUrogenitaleEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaRelazioneSanitariaApparatoUrogenitaleEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports